<template>
  <div id="dashboard-container" class="home">
    <to-do-index :showing="showing" />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import formSubmitterServer from "../../server/formSubmitter";
import eocServer from "../../server/eoc";
import documentServer from "../../server/document";
import documentGroupServer from "../../server/documentGroup";
import { calculateDaysFrom, formatDate } from "../../helpers/date";
import ToDoIndex from "./ToDoIndex.vue";
import moment from "moment";

export default {
  name: "HomeIndex",
  components: {
    ToDoIndex
  },
  props: ["showing"],
  data() {
    const self = this;
    return {
      list: [],
      filter: {
        page: 0,
        pageSize: 50,
        orderBy: "creationDate",
        orderByDescending: false
      },
      gridConfig: {
        minHeight: "20em",
        selectionMode: {
          row: true
        },
        columnLines: false,
        store: {
          // Default sorters
          sorters: [{ field: "creationDate", ascending: false }]
        }
      },
      listeners: {
        storeSort: sortData => {
          if (sortData.sorters.length == 1) {
            const sorter = sortData.sorters[0];
            const ascending = sorter.ascending;
            const field = sorter.field;
            self.filter.orderBy = field;
            self.filter.orderByDescending = !ascending;
            self.fetchMyPendingDocuments();
          }
        }
      },
      showAddFileEditor: false,
      editFile: {
        submitId: null,
        formId: null,
        clientId: null,
        eocId: null
      },
      showAddDocumentEditor: false,
      editDocument: {
        submitId: null,
        formId: null,
        clientId: null,
        eocId: null
      },
      showAddDocumentGroupEditor: false,
      editDocumentGroup: {
        submitId: null,
        formGroupId: null,
        clientId: null,
        eocId: null
      },
      documentViewModal: {
        show: false,
        id: null
      },
      documentGroupViewModal: {
        show: false,
        formGroupId: null,
        documentGroupId: null
      },
      summary: [],
      episodeOfCareLineChartStyles: {
        height: "100%"
      },
      episodeOfCareLineChartOptions: {
        cubicInterpolationMode: "monotone",
        height: 100,
        maintainAspectRatio: false,
        scales: {
          y: {
            ticks: {
              min: 0
            },
            grid: {
              drawOnChartArea: false
            }
          },
          x: {
            grid: {
              drawOnChartArea: false
            }
          }
        },
        elements: {
          point: {
            radius: 4,
            hoverRadius: 7,
            borderWidth: 3,
            hoverBorderWidth: 3
          }
        },
        plugins: {
          legend: { display: false }
        }
      },
      episodeOfCareLineChartData: null
    };
  },
  mounted() {
    this.fetchInitialData();
  },
  methods: {
    fetchInitialData() {
      // this.fetchSummary();
      // this.fetchMyPendingDocuments();
      // this.fetchAdmissionsPerMonth();
    },
    async fetchSummary() {
      this.summary = await eocServer.getSummary();
    },
    async fetchMyPendingDocuments() {
      if (this.currentUser) {
        const result = await documentServer.queryImproved({
          episodeOfCareId: [],
          formId: [],
          status: ["pending", "draft"],
          fromDate: null,
          toDate: null,
          effectiveFromDate: null,
          effectiveToDate: null,
          createdBy: [this.currentUser.id],
          page: 0,
          pageSize: 50,
          orderBy: this.filter.orderBy,
          orderByDescending: this.filter.orderByDescending,
          category: [
            "main",
            "groupSession",
            "masterTreatmentPlan",
            "masterTreatmentPlanReview",
            "doctorOrder"
          ]
        });
        this.list = result.documents;
        this.listTotal = result.count;
      }
    },
    async fetchAdmissionsPerMonth() {
      const admissionsMonthSummary = await eocServer.getAdmissionsMonthSummary();
      if (admissionsMonthSummary.length > 0) {
        let maxValue = 0;
        const labels = [""];
        const data = [0];

        let initialDate = moment(
          `${
            admissionsMonthSummary[0].year
          }-${admissionsMonthSummary[0].month.toString().padStart(2, "0")}-01`
        );
        var lastDate = moment(
          `${
            admissionsMonthSummary[admissionsMonthSummary.length - 1].year
          }-${admissionsMonthSummary[admissionsMonthSummary.length - 1].month
            .toString()
            .padStart(2, "0")}-01`
        );
        while (initialDate <= lastDate) {
          labels.push(initialDate.format("MMM YYYY"));
          const value = admissionsMonthSummary.find(
            summary =>
              `${summary.year}-${summary.month.toString().padStart(2, "0")}` ==
              initialDate.format("YYYY-MM")
          );
          if (value) {
            data.push(value.total);
            if (value.total > maxValue) maxValue = value.total;
          } else data.push(0);

          initialDate = initialDate.add(1, "month");
        }

        this.episodeOfCareLineChartData = {
          labels: labels,
          datasets: [
            {
              label: "Admissions per month",
              borderColor: "#2196F3",
              pointBackgroundColor: "rgba(21, 150, 243, 1)",
              backgroundColor: "rgba(21, 150, 243, 0.1)",
              data: data,
              cubicInterpolationMode: "monotone",
              fill: true
            }
          ]
        };
        this.episodeOfCareLineChartOptions.scales.y.ticks.max = maxValue + 1;
      }
    },
    onModifyAddFile(eventData) {
      this.showAddFileEditor = false;
      if (eventData.refetchDocuments) this.fetchMyPendingDocuments();
    },
    onModifyAddDocument(eventData) {
      this.showAddDocumentEditor = false;
      if (eventData.refetchDocuments) this.fetchMyPendingDocuments();
    },
    onModifyAddDocumentGroup(eventData) {
      this.showAddDocumentGroupEditor = false;
      if (eventData.refetchDocuments) this.fetchMyPendingDocuments();
    },
    openDocumentEditor(record) {
      if (record.mode == "File") {
        this.editFile.submitId = record.documentId;
        this.editFile.clientId = record.patient.id;
        this.editFile.eocId = record.episodeOfCare.id;
        this.editFile.formId = record.form.id;
        this.showAddFileEditor = true;
      } else if (record.type == "Document") {
        this.editDocument.submitId = record.documentId;
        this.editDocument.clientId = record.patient.id;
        this.editDocument.eocId = record.episodeOfCare.id;
        this.editDocument.formId = record.form.id;
        this.showAddDocumentEditor = true;
      } else {
        this.editDocumentGroup.submitId = record.documentId;
        this.editDocumentGroup.clientId = record.patient.id;
        this.editDocumentGroup.eocId = record.episodeOfCare.id;
        this.editDocumentGroup.formGroupId = record.form.id;
        this.showAddDocumentGroupEditor = true;
      }

      this.showDocumentViewModal = { show: false, id: null };
    },
    attachHookDropdownButtons() {
      if (this.items.length > 0) this.hookDropdownButtons();
    }
  },
  computed: {
    ...mapState("layout", {
      currentUser: state => state.currentUser
    }),
    ...mapGetters("layout", ["hasCurrentUserDocumentPermission"]),
    summaryPending() {
      let pendingCount = 0;
      const summaryValue = this.summary.find(s => s.status == "Pending");
      if (summaryValue) pendingCount = summaryValue.count;
      return pendingCount;
    },
    summaryActive() {
      let activeCount = 0;
      const summaryValue = this.summary.find(
        s => s.status == "Active" && !s.levelOfCare
      );
      if (summaryValue) activeCount = summaryValue.count;
      return activeCount;
    },
    summaryInactive() {
      let dischargedCount = 0;
      const summaryValue = this.summary.find(s => s.status == "Inactive");
      if (summaryValue) dischargedCount = summaryValue.count;
      return dischargedCount;
    },
    summaryActiveLevelsOfCare() {
      return this.summary.filter(s => s.status == "Active" && s.levelOfCare);
    },
    items() {
      let newList = this.list;
      newList.sort((a, b) => {
        let aValue = a[this.orderBy];
        let bValue = b[this.orderBy];
        if (this.orderBy && this.orderBy.includes(".")) {
          aValue = a.results[this.orderBy.split(".")[1]];
          bValue = b.results[this.orderBy.split(".")[1]];
        }
        if (!aValue) aValue = "";
        if (!bValue) bValue = "";
        return (
          aValue.toString().localeCompare(bValue.toString()) *
          (this.orderByDescending ? -1 : 1)
        );
      });
      return newList;
    },
    columns() {
      const self = this;
      return [
        {
          text: "Ref#",
          field: "documentRefNumber",
          width: 60,
          editor: false
        },
        {
          text: "Document Type",
          field: "documentType",
          type: "template",
          flex: 1,
          editor: false,
          template: ({ record }) => {
            let formName = record.data.form ? record.data.form.name : "";
            if (record.data.form.category == "masterTreatmentPlan")
              formName = "Treatment Plan";
            if (
              record.data.form.category == "masterTreatmentPlan" &&
              record.data.parentDocumentId
            )
              formName = "Treatment Plan Review";
            return (
              formName +
              (record.data.type == "Document" && record.data.mode == "File"
                ? "<i class='fa fa-file-upload text-info ml-2'></i>"
                : "") +
              (record.data.fileName ? ` (${record.data.fileName})` : "")
            );
          },
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Patient Name",
          field: "patientName",
          type: "template",
          flex: 1,
          editor: false,
          template: data =>
            data.record.data.patient
              ? this.formatEoc(
                  data.record.data.patient.firstName,
                  data.record.data.patient.middleName,
                  data.record.data.patient.preferredName,
                  data.record.data.patient.lastName,
                  data.record.data.patient.mrn,
                  data.record.data.episodeOfCare.eocn
                )
              : "",
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Patient Start",
          field: "admissionDate",
          type: "template",
          width: 160,
          editor: false,
          template: data =>
            data.record.data.episodeOfCare.startDate
              ? formatDate(data.record.data.episodeOfCare.startDate)
              : "",
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Status",
          field: "status",
          type: "template",
          width: 120,
          editor: false,
          template: data => {
            let className = "warning";
            let statusText = "Pending";
            if (data.record.data.status == "Completed") {
              className = "success";
              statusText = "Completed";
            }
            if (data.record.data.status == "Draft") {
              className = "danger";
              statusText = "Draft";
            }
            return `<span class="badge-v2 py-2 badge-${className} badge-fixed-size">${statusText}</span>`;
          },
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Pending since",
          field: "pendingSince",
          type: "template",
          width: 160,
          editor: false,
          template: data =>
            data.record.data.createdAt
              ? `<span style="color: red">Pending for ${calculateDaysFrom(
                  data.record.data.createdAt
                )} days</span>`
              : "",
          sortable: false
        },
        {
          text: "Effective date",
          field: "effectiveDate",
          type: "template",
          width: 160,
          editor: false,
          template: data =>
            data.record.data.effectiveDate
              ? formatDate(data.record.data.effectiveDate)
              : "",
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Creation date",
          field: "creationDate",
          type: "template",
          width: 160,
          editor: false,
          template: data => formatDate(data.record.data.createdAt),
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Score",
          field: "scoreAndNotes",
          type: "template",
          flex: 1,
          template: ({ record }) => {
            return record.data.score ? record.data.score : "";
          },
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "",
          type: "action",
          cellCls: "pointer-cell",
          align: "right",
          width: 80,
          actions: [
            {
              renderer: () =>
                `<i class="fa fa-search-plus color-custom-dark-grey hover-text-primary b-action-item grid-action-icon"></i>`,
              onClick: ({ record }) => {
                if (record.data.mode == "File") {
                  const url = formSubmitterServer.viewUrl(
                    record.data.documentId
                  );
                  window.open(url, "_blank");
                } else if (record.data.type == "Group") {
                  this.documentGroupViewModal = {
                    show: true,
                    formGroupId: record.data.form.id,
                    documentGroupId: record.data.documentId
                  };
                } else {
                  this.documentViewModal = {
                    show: true,
                    id: record.data.documentId
                  };
                }
              }
            },
            {
              renderer: ({ record }) => {
                const actions = [];

                if (
                  (record.status == "Completed" &&
                    this.hasCurrentUserDocumentPermission(
                      record.form.id,
                      "hasCompleteAccess"
                    )) ||
                  (record.status != "Completed" &&
                    this.hasCurrentUserDocumentPermission(
                      record.form.id,
                      "hasEntryAccess"
                    )) ||
                  record.category != "groupSession"
                ) {
                  actions.push({
                    content: "Edit",
                    callback: () => this.openDocumentEditor(record)
                  });
                }

                if (
                  record.status != "Completed" &&
                  this.hasCurrentUserDocumentPermission(
                    record.form.id,
                    "hasEntryAccess"
                  ) &&
                  (record.category == "main" ||
                    record.category == "masterTreatmentPlan" ||
                    record.category == "doctorOrder")
                ) {
                  actions.push({
                    content: "Delete",
                    callback: () => {
                      this.$dialog
                        .alert(
                          {
                            title:
                              "Are you sure you want to delete this record?"
                          },
                          {
                            view: "confirm-delete"
                          }
                        )
                        .then(async () => {
                          let result = null;
                          if (record.type == "Document")
                            result = await formSubmitterServer.delete(
                              record.documentId
                            );
                          else
                            result = await documentGroupServer.delete(
                              record.documentId
                            );
                          if (result.errorCode) {
                            this.$dialog.alert("Error: " + result.message);
                          } else {
                            this.fetchMyPendingDocuments();
                            this.showAlertSuccess();
                          }
                        });
                    }
                  });
                }

                return this.createDropdownButton({
                  items: actions
                });
              }
            }
          ]
        }
      ];
    }
  },
  watch: {
    showing: async function(newValue) {
      if (newValue) {
        this.fetchInitialData();
      }
    },
    currentUser: async function(newValue, oldValue) {
      if (newValue && !oldValue) {
        this.fetchMyPendingDocuments();
      }
    }
  }
};
</script>

<style scoped>
.dashboard-container {
  height: calc(100vh - 65px);
  overflow-x: hidden;
  overflow-y: auto;
  box-shadow: inset 0px 16px 10px -16px rgb(0 0 0 / 75%);
}
.summary-item {
  min-width: 150px;
  height: 150px;
  flex: 1;
}
.summary-item-number {
  font-size: 60px;
}
.summary-item-text {
  font-size: 20px;
}
.eoc-chart-container {
  height: 215px;
  padding-top: 33px;
}
.eoc-summary-container {
  height: 200px;
  padding: 10px 0px;
}
.eoc-status-line {
  position: absolute;
  left: 14px;
  height: 68px;
  width: 2px;
  background-color: #dcdfe2 !important;
}
.eoc-status-circle {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.eoc-status-data {
  height: 98px;
}
.eoc-status-data-title {
  font-size: 13px;
  margin-bottom: -7px;
  color: grey;
}
.eoc-status-data-amount {
  font-size: 45px;
  color: black;
}
.chart-subtitle {
  padding-top: 3px;
  padding-bottom: 8px;
  font-size: 14px;
}
.chart-title-separator {
  margin-top: 10px;
  width: 40px;
  height: 5px;
  border-radius: 10px;
}
.home-section {
  border-radius: 15px;
  padding: 30px 40px;
}
.recent-documents-container >>> .b-grid-container .b-container {
  max-height: calc(100vh - 559px);
  min-height: calc(100vh - 559px) !important;
}

.home {
  padding: 0 20px 0 20px;
}
</style>
